/**
 * Enumeration of all pages
 */
export enum Page {
    Canvas = "game-canvas",
    CablePuzzle = "cable-puzzle",
    CablePuzzlePage = "cable-puzzle-page",
}
